import styled from "styled-components";
import { Button as ButtonAnt } from "antd";

interface IButton {
  actionType:
    | "default"
    | "send"
    | "inactivate"
    | "activate"
    | "activate_courses_mass"
    | "update_magic_link";
}

export const Button = styled(ButtonAnt)<IButton>`
  border-radius: 0.3rem;
  white-space: normal;
  height: auto;
  padding: 0.25rem 0.9375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 2rem;

  &&&:disabled {
    background-color: #d4d4d4;
    color: #a09d9d;
    &&&:hover {
      background-color: #d4d4d4;
    }
  }

  ${({ actionType }) => {
    if (actionType === "default") {
      return `
        background-color: var(--gray-100);
      `;
    }
  }}

  @media (max-width: 576px) {
    width: 100%;
    font-size: 0.9rem;
    padding: 0.25rem 0.5rem;
    min-height: 2.25rem;
  }
`;

export const ImportantInfo = styled.div`
  background-color: rgba(255, 122, 0, 0.1);
  border-left: 0.25rem solid var(--orange-150);
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-radius: 0.3rem;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--gray-700);

  strong {
    color: var(--orange-150);
  }

  @media (max-width: 576px) {
    font-size: 0.9rem;
    padding: 0.75rem;
  }
`;

export const HelpSection = styled.div`
  margin-bottom: 1.5rem;
`;

export const HelpTitle = styled.h3`
  font-size: 1rem;
  color: var(--orange-100);
  margin-bottom: 0.5rem;
`;

export const HelpText = styled.div`
  font-size: 1rem;
  color: var(--gray-700);
  line-height: 1.6;

  strong {
    color: var(--gray-900);
  }

  @media (max-width: 576px) {
    font-size: 0.9rem;
  }
`;

export const ModalContainer = styled.div`
  max-height: 50vh;
  overflow-y: auto;
  padding-right: 0.625rem;

  @media (max-width: 576px) {
    max-height: 40vh;
  }

  &::-webkit-scrollbar {
    width: 0.375rem;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 0.625rem;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--gray-150);
    border-radius: 0.625rem;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--gray-530);
  }
`;
